import styled from 'styled-components';
import { devices } from '../../utilities/responsive';

export const Creator = styled.div`
    width: 100%;
    margin-bottom: 30px;
    display: flex;
    justify-content: flex-start;

   @media ${devices.phoneLg}  {
        flex-wrap: wrap;
   }
    
`;

export const ImageWrapper = styled.div`
    margin-bottom: 30px;
    margin-right: 2em;
    border-radius: 50%;
    min-width: 100px;
    min-height: 100px;
    max-width: 100px;
    max-height: 100px;
    overflow: hidden;

    @media ${devices.tabletLandscape} {
        width: 70px;
        height: 70px;
    }

    @media ${devices.phoneLg}  {
        width: 70px;
        height: 70px;
        margin: 0 auto 2em;
        text-align: center;
    }

    img {
        object-fit: cover;
        height: 100%;
        width: 100%;
    }
`;

export const CreatorInfo = styled.div`
    p {
        font-size: 16px;
    }
`;

